import 'babel-polyfill';
import 'reactApp/fonts.css';
import 'semantic-ui-css/semantic.min.css';

import _ from 'Cloud/Application/_';
import app from 'Cloud/Application/app';
import browser from 'Cloud/Application/Browser';
import publicFunc from 'Cloud/Application/Public';
import rubles from 'Cloud/Application/Rubles';
import tree from 'Cloud/Application/Tree';
import user from 'Cloud/Application/User';
import { ERROR_PAGE_STATUS, IS_PHONE_BROWSER, IS_PUBLIC, PUBLIC_ERROR_PAGE_STATUS, USER } from 'reactApp/appHelpers/configHelpers';
import { initRouterMock } from 'reactApp/modules/start/RouterMock';
import { EErrorPageAction, sendErrorPageAnalytics } from 'reactApp/sections/ErrorPage/ErrorPage.analytics';
import { EStatus } from 'reactApp/sections/ErrorPage/ErrorPage.types';
import { ESiteZoneErrorPage } from 'reactApp/ui/AdvBanners/Adv.types';
import { EButtonAction, sendDisableAdsAnalytics } from 'reactApp/ui/AdvBanners/DisableButton/DisableButton.analytics';

const isPhone = IS_PHONE_BROWSER || window.matchMedia("(max-width: 768px)").matches;
const errorStatus = PUBLIC_ERROR_PAGE_STATUS || ERROR_PAGE_STATUS;

const getDwhSource = () => {
    if (IS_PUBLIC) {
        return 'public';
    }

    // На статичных (nginx) страницах ошибок мы не знаем source.
    if (isPhone) {
        return 'touch';
    }

    return 'web';
}

const initButtonClick = () => {
    const button = document.querySelector('.js-error-page-button');
    const source = getDwhSource();

    button.addEventListener('click', (e) => {
        sendErrorPageAnalytics({
            action: EErrorPageAction.CLICK,
            number_error: errorStatus,
            source
        });
    });
}

const initDisableAdAnalytics = () => {
    const button = document.querySelector('.js-disable-button');

    if (!button) {
        return;
    }

    sendDisableAdsAnalytics({
        action: EButtonAction.SHOW,            
        source: errorStatus, 
        place: 'error-page',
        platform: isPhone ? 'touch' : 'desktop',
    });

    button.addEventListener('click', () => {
        sendDisableAdsAnalytics({
            action: EButtonAction.CLICK,
            source: errorStatus, 
            place: 'error-page',
            platform: isPhone ? 'touch' : 'desktop',
        });
    });
};

const fetchUser = async () => {
    if (USER) {
        return USER;
    }

    // Фолбек для статичных (nginx) страниц ошибок.
    try {
        const tokenRequest = await fetch('/api/v3/tokens/csrf', { method: 'POST' });
        const { token } = await tokenRequest.json();

        if (token) {
            const userRequest = await fetch('/api/v2/user', {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'x-csrf-token': token
                },
            });
            const userInfo = await userRequest.json();

            return userInfo?.body;
        }

        return;
    } catch(error) {
        console.error(error);
    }
}

const showAdvHeaderDesktop = () => {
    const element = document.querySelector('.js-header-error-page');
    element?.classList.add('js-header-error-page--visible');
}

const showAdv = () => {
    const errorStatusText = errorStatus && EStatus[errorStatus];
    const siteZone = errorStatusText && ESiteZoneErrorPage[errorStatusText];
    const source = getDwhSource();

    if (isPhone) {
        app.Rubles?.updateErrorPagePhoneTopAdv(+siteZone);
    } else {
        showAdvHeaderDesktop();
        app.Rubles?.updateErrorPageRightColAdv(+siteZone);
    }

    initDisableAdAnalytics();

    sendErrorPageAnalytics({
        action: EErrorPageAction.SHOW,
        number_error: errorStatus,
        source
    });
}

const checkShowAdv = (user) => {
    const { account_type, cloudflags } = user || {};

    if (account_type === 'pdd') {
        return false;
    }

    if (cloudflags?.CORP || cloudflags?.PAID_ACCOUNT) {
        return false;
    }

    return true;
}

const initAdvApp = async () => {
    const user = await fetchUser();
    initButtonClick();

    if (checkShowAdv(user)) {
        showAdv();
    }
}

try {
    // Фикс прелоадера.
    window.ContentLoader?.setJSLoaded?.();
    // 5 функций ниже необходимо заинитить, чтобы заработал rubles() без ошибок.
    initRouterMock(app);
    browser(app);
    user();
    publicFunc();
    tree(app, _);
    rubles();
    initAdvApp();
} catch (error) {
    console.error(error);
}
